<template>
	<ListDetailLayout
			:store="deviceManufacturersStore"
      index-route-name="admin.devices.manufacturers"
			create-permissions="create:device-manufacturers"
			@on-create="$router.push({ name: 'admin.devices.manufacturers.manufacturer', params: { manufacturer: 'NEW' } })"
			@on-paginate="(page) => useOnPaginate(page, refreshDeviceManufacturers, params)"
			@on-search="(page) => useOnSearch(page, refreshDeviceManufacturers, params)"
			create-button-admin-page="create-device-manufacturer-admin-btn"
	        search-admin-page="search-device-manufacturer-admin-page"
	>

		<template #list>
			<li v-for="manufacturer in deviceManufacturersStore.getDeviceManufacturers" :key="manufacturer.id">
				<router-link
						:to="{ name: 'admin.devices.manufacturers.manufacturer', params: { manufacturer: manufacturer.id } }"
						v-slot="{isActive}">
					<div
							:class="[isActive ? 'border-primary-500 dark:bg-surface-600' : 'border-transparent hover:bg-surface-50 dark:hover:bg-surface-800', 'transition-colors border-l-4 flex items-center justify-between gap-x-6 py-5 pl-3 pr-4 bg-surface-0 dark:bg-surface-800']">

						<div class="min-w-0">
							<div class="flex items-start gap-x-3">
								<p class="text-sm font-semibold leading-6 text-surface-900 dark:text-surface-200">
                  {{ manufacturer.name }}
                </p>
							</div>

							<div class="mt-1 flex items-center gap-x-2 text-xs leading-5 text-surface-500 dark:text-surface-400">
								<p class="whitespace-nowrap">
									{{ manufacturerCompanyLabel(manufacturer) }}
								</p>
							</div>
						</div>

					</div>
				</router-link>
			</li>
		</template>

		<template #detail>
			<router-view v-if="$route.params.manufacturer" @on-save="refreshDeviceManufacturers"
			             @on-delete="refreshDeviceManufacturers"></router-view>
		</template>

	</ListDetailLayout>
</template>

<script>
import ListDetailLayout from "@/Layouts/ListDetailLayout.vue";
import Container from "@/Components/Container.vue";
import { mapStores } from "pinia";
import { useDeviceManufacturersStore } from "@/stores/deviceManufacturers.js";
import { useOnPaginate, useOnSearch } from "@/Composables/Pagination.js";

export default {
	name: "DeviceManufacturersIndex",
	data() {
		return {
			params: {
				include: ['company', 'companies'],
			}
		}
	},
	methods: {
		useOnSearch,
		useOnPaginate,
		refreshDeviceManufacturers() {
			return this.deviceManufacturersStore.indexDeviceManufacturers(this.params);
		},
		manufacturerCompanyLabel(manufacturer) {
			if (manufacturer.companies?.length) {
				return manufacturer.companies.map(company => company.name).join(', ');
			}

			return manufacturer.company?.name ?? this.$t('common.public');
		},
	},
	components: {Container, ListDetailLayout},
	computed: {
		...mapStores(useDeviceManufacturersStore)
	},
	async mounted() {
		await this.refreshDeviceManufacturers();
	}
}
</script>
